import { AfterViewInit, Directive, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';
import { UIMenuCategoryDto } from 'src/app/shared/interfaces/ui-menu-category-dto.interface';
import { MenuListRepository } from 'src/app/shared/repositories/menu-list.repository';
import { SeparateTask } from 'src/app/shared/utils/separate-task';

@Directive()
export abstract class MainPageAbstract implements AfterViewInit {
  @ViewChild('bannerView', { read: ViewContainerRef }) bannerView: ViewContainerRef;

  categories$: Observable<UIMenuCategoryDto[] | null> = this.menuListRepository.menuNavCategories$;
  loadingMenuStatus$: Observable<boolean> = this.menuListRepository.loadingMenuStatus$;

  constructor(
    protected menuListRepository: MenuListRepository,
  ) { }

  ngAfterViewInit(): void {
    void this.loadBanner();
  }

  @SeparateTask()
  async loadBanner(): Promise<void> {
    this.bannerView.clear();
    const { BannerSliderComponent } = await import('../../blocks/banner-slider/banner-slider.component');
    this.bannerView.createComponent(BannerSliderComponent);
  }
}